import type { SVGProps } from "react";

export function Api(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.75 12.25L4.55357 9.57143M4.55357 9.57143L5.90422 5.06928C5.93272 4.97426 6.06728 4.97426 6.09578 5.06928L7.44643 9.57143M4.55357 9.57143H7.44643M7.44643 9.57143L8.25 12.25M10.5 12.25V8.75M10.5 8.75V4.85C10.5 4.79477 10.5448 4.75 10.6 4.75H12.25C12.6875 4.75 14 4.75 14 6.75C14 8.75 12.6875 8.75 12.25 8.75H10.5ZM16.75 4.75V12.25M3.25 16H18.25C19.4926 16 20.5 14.9926 20.5 13.75V3.25C20.5 2.00736 19.4926 1 18.25 1H3.25C2.00736 1 1 2.00736 1 3.25V13.75C1 14.9926 2.00736 16 3.25 16Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
